// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDvvQIerKsg-TTXqqKqwKfF4Dlq98pIRSQ",
    authDomain: "hzvt-db-auth-and-faults.firebaseapp.com",
    projectId: "hzvt-db-auth-and-faults",
    storageBucket: "hzvt-db-auth-and-faults.firebasestorage.app",
    messagingSenderId: "343906802326",
    appId: "1:343906802326:web:7a904e71b4d86dab97c0b7",
    measurementId: "G-23EM75VS86"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Firebase Authentication
export const auth = getAuth(app);

export default app;
